import { useGlobalStyles } from "./globalStyles";
import coffeePlant from "../assets/images/Home/coffee-plant-illustration.webp";
import coffeeBeans from "../assets/images/Home/coffee-beans-illustration.webp";

// Shared decorative background (pattern + illustrations) for Login, Two-Step Verification, and Forget Password.
export default function AuthPageBackground() {
  const classes = useGlobalStyles() as Record<string, string>;

  return (
    <>
      <div className={classes.loginBgPattern} aria-hidden="true" />
      <img src={coffeePlant} alt="" className={classes.loginBgIllustration} aria-hidden="true" />
      <img src={coffeeBeans} alt="" className={classes.loginBgIllustrationBeans} aria-hidden="true" />
    </>
  );
}
